import { 
  faHatWizard,
  faFilm,
  faCertificate,
  faComments,
  faBookReader,
  faGamepad,
  faBasketballBall,
  faMusic,
  faWater,
  faPuzzlePiece,
  faCode,
} from '@fortawesome/free-solid-svg-icons'

export const jobData = [
  {
    id: 1,
    company: 'Coinbase, Inc.',
    notes: '(Contract through Sove IT Strategists',
    city: 'Los Angeles, CA (Remote)',
    begDate: 'Feb 2021',
    endDate: 'Present',
    jobTitle: 'Sr Accountant',
    responsibilities: `Duties and responsibilities mainly consist of assisting
    in ensuring the proper accounting treatment for a subsidiary under Coinbase,
    Inc., which transacts with institutional investors.`,
    accomplishments: [
    ]
  },
  {
    id: 2,
    company: 'Prospect Medical Holdings, Inc.',
    notes: '(Contract through Beacon DLC)',
    city: 'Los Angeles, CA',
    begDate: 'Aug 2019',
    endDate: 'March 2020',
    jobTitle: 'Interim Controller',
    responsibilities: 'Acting Controller for holding entity primarily dealing with intercompany transactions and netting; reporting directly to the CFO.',
    accomplishments: [
      'Automated the delivery of intercompany transactions for 16 facilities.',
      'Implemented procedures to reduce the preparation of cash entries by 4 hours.'
    ]
  },
  {
    id: 3,
    company: 'Atom Tickets, LLC',
    notes: '',
    city: 'Santa Monica, CA',
    begDate: 'Jan 2019',
    endDate: 'July 2019',
    jobTitle: 'Assistant Controller',
    responsibilities: `Assisted in managing and monitoring all accounting
    operations to ensure timely, complete, and accurate financial data.`,
    accomplishments: [
      'Shortened vendor payment cycles by 4 days.',
      'Automated invoice creation and disbursement for Accounts Receivables.',
      'Streamlined QuickBooks procedures to shorten close.',
      'Automated creation of financials from QuickBooks.',
      'Created a querying tool to facilitate accounting research.'
    ]
  },
  {
    id: 4,
    company: 'National Planning Holdings, Inc.,',
    notes: '(A Jackson National Life affiliate)',
    city: 'Playa Vista, CA',
    begDate: 'Jan 2013',
    endDate: 'Dec 2018',
    jobTitle: 'Manager of Accounting ',
    responsibilities: `Oversaw the accurate and timely accounting over
    commission revenue ($ 1B plus annually) and expenses for four companies.`,
    accomplishments: [
      'Collaborated with Asst. Controller, Controller, and CFO, who are Big 4 (KPMG) alumni ',
      'Provided coaching and development to team members',
      'Developed and implemented new processes due to legal and organizational changes',
      'Enforced and monitored internal controls',
      'Assisted with the annual audit process from internal and external regulatory bodies',
      'Interviewed, hired, and trained new staff',
      'Ensured payment of liabilities, and collection of receivables',
      'Successfully completed 132 month-end closes over 11-year career',
      'Performed the functions of 4 people after company was sold',
    ]
  },
  {
    id: 5,
    company: 'National Planning Holdings, Inc.,',
    notes: '(A Jackson National Life affiliate)',
    city: 'Playa Vista, CA',
    begDate: 'Jan 2010',
    endDate: 'Dec 2012',
    jobTitle: 'Sr. Accountant',
    responsibilities: `Reviewed and approved journal entries, reconciliations,
    and revenue reporting.`,
    accomplishments: [
      'Automated several journal entries for the commissions department, saving 16 hours a month',
      'Automated report to analyze net capital variances and deficiencies, saving 8 hours a month',
      'Created and improved policies and procedures for accrual methodologies and revenue journal entries',
      'Automated aging receivables report, saving 4 hours a month',
      'Automated cash to accrual reporting for all revenue streams, saving 8 hours a month',
    ]
  },
  {
    id: 6,
    company: 'National Planning Holdings, Inc.,',
    notes: '(A Jackson National Life affiliate)',
    city: 'Playa Vista, CA',
    begDate: 'Oct 2007',
    endDate: 'Dec 2009',
    jobTitle: 'Staff Accountant',
    responsibilities: `Prepared journal entries for commission revenue and
    expenses, account receivable, payroll, intercompany allocations, and any
    other miscellaneous entries.`,
    accomplishments: [
      
    ]
  },
]

export const jobDataFull = [
  {
    id: 1,
    company: 'Coinbase, Inc.',
    notes: '(Contract through Solve IT Strategist)',
    city: 'Los Angeles, CA (Remote)',
    begDate: 'Feb 2021',
    endDate: 'Present',
    jobTitle: 'Sr Accountant',
    responsibilities: `Duties and responsibilities mainly consist of assisting
    in ensuring the proper accounting treatment for a subsidiary under Coinbase,
    Inc., which transacts with institutional investors. Duties include recording
    of cash, custodial liabilities, receivables, payables, revenue, operating
    expenses, crypto-currency inventory, and any miscellaneous items that may
    arise during month-end close. Duties also include preparing reconciliations,
    writing documents and procedures, fluctuation analysis, and assisting in ad
    hoc requests and projects.`,
    accomplishments: [
    ]
  },
  {
    id: 2,
    company: 'Prospect Medical Holdings, Inc.',
    notes: '(Contract through Beacon DLC)',
    city: 'Los Angeles, CA',
    begDate: 'Aug 2019',
    endDate: 'March 2020',
    jobTitle: 'Interim Controller',
    responsibilities: `Acting Controller for holding entity primarily dealing
    with intercompany transactions and netting; reporting directly to the CFO.
    Responsibilities include preparing and reviewing reconciliations, ensuring
    proper expense and revenue recognition. Preparing all adjusting entries for
    month close. Maintaining and preparing prepaid amortization schedules.
    Preparing Financial Statements and accompanying fluctuation analysis.
    Assisting in yearly audit and implementing policies and procedures.`,
    accomplishments: [
      'Automated the delivery of intercompany transactions for 16 facilities.',
      'Implemented procedures to reduce the preparation of cash entries by 4 hours.'
    ]
  },
  {
    id: 3,
    company: 'Atom Tickets, LLC',
    notes: '',
    city: 'Santa Monica, CA',
    begDate: 'Jan 2019',
    endDate: 'July 2019',
    jobTitle: 'Assistant Controller',
    responsibilities: `Assisted in managing and monitoring all accounting
    operations to ensure timely, complete, and accurate financial data.
    Responsibilities included but were not limited to, establishing and
    maintaining internal control policies, leading annual audit process,
    reviewing reconciliations, ensuring proper expense and revenue recognition,
    overseeing cash disbursements, performing forecasts, analyzing monthly
    variances, and preparing financial statements.`,
    accomplishments: [
      'Shortened vendor payment cycles by 4 days.',
      'Automated invoice creation and disbursement for Accounts Receivables.',
      'Streamlined QuickBooks procedures to shorten close.',
      'Automated creation of financials from QuickBooks.',
      'Created a querying tool to facilitate accounting research.'
    ]
  },
  {
    id: 4,
    company: 'National Planning Holdings, Inc.,',
    notes: '(A Jackson National Life affiliate)',
    city: 'Playa Vista, CA',
    begDate: 'Jan 2013',
    endDate: 'Dec 2018',
    jobTitle: 'Manager of Accounting ',
    responsibilities: `Oversaw the accurate and timely accounting over
    commission revenue ($ 1B plus annually) and expenses for four companies.
    Responsibilities included maintaining and implementing respective policies
    and procedures, reviewing journal entries, accruals and reconciliations for
    the monthly financial close, regulatory reporting for the Financial Industry
    Regulatory Authority (FINRA, a non-profit regulatory body overseen by the
    SEC), and oversight over net capital. Assisted in budgeting and forecasting.
    Provided financial reporting and ad hoc requests to senior management.
    Managed cash, reviewed and approved wire transfers. Reviewed balance sheet
    and income statement to ensure accurate, complete, and appropriate
    presentation.  Directly managed two individuals, supervised up to 12
    individuals based on need (Accounting Department consisted of 25 employees).`,
    accomplishments: [
      'Collaborated with Asst. Controller, Controller, and CFO, who are Big 4 (KPMG) alumni ',
      'Provided coaching and development to team members',
      'Developed and implemented new processes due to legal and organizational changes',
      'Enforced and monitored internal controls',
      'Assisted with the annual audit process from internal and external regulatory bodies',
      'Interviewed, hired, and trained new staff',
      'Ensured payment of liabilities, and collection of receivables',
      'Successfully completed 132 month-end closes over 11-year career',
      'Performed the functions of 4 people after company was sold',
    ]
  },
  {
    id: 5,
    company: 'National Planning Holdings, Inc.,',
    notes: '(A Jackson National Life affiliate)',
    city: 'Playa Vista, CA',
    begDate: 'Jan 2010',
    endDate: 'Dec 2012',
    jobTitle: 'Sr. Accountant',
    responsibilities: 'Reviewed and approved journal entries, reconciliations, and revenue reporting.  Maintained books and records in accordance with GAAP. Analyzed and explained fluctuations in assigned financial statement line items. Compiled and analyzed various monthly reports for management. Performed month-end closing. Assisted in the maintenance of the chart of accounts. Tracked receivables. Prepared and submitted financial statements of position to FINRA.',
    accomplishments: [
      'Automated several journal entries for the commissions department, saving 16 hours a month',
      'Automated report to analyze net capital variances and deficiencies, saving 8 hours a month',
      'Created and improved policies and procedures for accrual methodologies and revenue journal entries',
      'Automated aging receivables report, saving 4 hours a month',
      'Automated cash to accrual reporting for all revenue streams, saving 8 hours a month',
    ]
  },
  {
    id: 6,
    company: 'National Planning Holdings, Inc.,',
    notes: '(A Jackson National Life affiliate)',
    city: 'Playa Vista, CA',
    begDate: 'Oct 2007',
    endDate: 'Dec 2010',
    jobTitle: 'Staff Accountant',
    responsibilities: 'Prepared journal entries for commission revenue and expenses, account receivable, payroll, intercompany allocations, and any other miscellaneous entries. Prepared wire transferred requests. Prepared reconciliations after month end closing. Assisted in data entry and prepared management reports.',
    accomplishments: [
      
    ]
  },
]

export const jobSkills = [ 
  {
    skill: "DRIVE",
    rating: 100,
  },
  {
    skill: "GRIT",
    rating: 100,
  },
  {
    skill: "CURIOSITY",
    rating: 100,
  },
  {
    skill: "DILIGENCE",
    rating: 100,
  },
  {
    skill: "REACT",
    rating: 80,
  },
  {
    skill: "JAVASCRIPT",
    rating: 80,
  },
  {
    skill: "JQUERY",
    rating: 60,
  },
  {
    skill: "NODE.JS",
    rating: 70,
  },
  {
    skill: "POSTGRESQL",
    rating: 70,
  },
  {
    skill: "HTML",
    rating: 80,
  },
  {
    skill: "CSS",
    rating: 80,
  },
  {
    skill: "EXPRESS.JS",
    rating: 70,
  },
  {
    skill: "GITHUB",
    rating: 80,
  },


]

export const schools = [
  {
    id:  1,
    school: "California State University, Northridge",
    city: "Northridge, CA",
    gradYear: "2007",
    degree: "Bachelor of Science, Accounting"
  },
  {
    id: 2,
    school: "Thinkful Bootcamp",
    city: "Los Angeles, CA",
    gradYear: "2020",
    degree: "Software Engineering Program (Fullstack)"

  }

]

export const certMisc = {
    cert: [ 
      {
      id: 1,
      type: "CPA",
      licNum: '# 136059',
      icon: faCertificate,
      }
    ],
    languages: [
      {
        id: 1,
        type: "Spanish",
        icon: faComments,
      }
    ],
    hobbies: [ 
      {
        id: 1,
        type: "Reading",
        icon: faBookReader,
      },
      {
        id: 2,
        type: "Video Games",
        icon: faGamepad,
      },
      {
        id: 3,
        type: "Watching Sports",
        icon: faBasketballBall,
      },
      {
        id: 4,
        type: "Fantasy Sports",
        icon: faHatWizard,
      },
      {
        id: 5,
        type: "Movies",
        icon: faFilm,
      },
      {
        id: 6,
        type: "Music",
        icon: faMusic,
      },
      {
        id: 7,
        type: "Rowing",
        icon: faWater
      },
      {
        id: 8,
        type: "Puzzles",
        icon: faPuzzlePiece,
      },
      {
        id: 9,
        type: "Coding",
        icon: faCode,
      },
    ]
}


export default {
  jobData,
  jobSkills,
  schools,
  certMisc,
}